document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.selling-plan').forEach(initSellingPlan);
});

function initSellingPlan(root) {
  const productForm = document.getElementById(root.dataset.productFormId);
  if (!productForm) return;

  const radios = root.querySelectorAll('.plan-radio');
  const dropdownWrap = root.querySelector('.plan-dropdown');
  const planSelect = root.querySelector('.plan-dropdown select');
  const subscribePriceEl = root.querySelector('.plan-option:last-child .plan-price__amount');

  let sellingPlanInput = productForm.querySelector('input[name="selling_plan"]');
  if (!sellingPlanInput) {
    sellingPlanInput = document.createElement('input');
    sellingPlanInput.type = 'hidden';
    sellingPlanInput.name = 'selling_plan';
    productForm.appendChild(sellingPlanInput);
  }

  function applyChoice(isSubscribed) {
    root.querySelectorAll('.plan-option').forEach((option) => option.classList.remove('is-selected'));
    const checkedRadio = root.querySelector('.plan-radio:checked');
    checkedRadio?.closest('.plan-option')?.classList.add('is-selected');

    if (isSubscribed) {
      if (dropdownWrap) dropdownWrap.hidden = false;
      sellingPlanInput.disabled = false;
      sellingPlanInput.value = planSelect ? planSelect.value : checkedRadio.value;
    } else {
      if (dropdownWrap) dropdownWrap.hidden = true;
      sellingPlanInput.disabled = true;
      sellingPlanInput.value = '';
    }
  }

  radios.forEach((radio) => {
    radio.addEventListener('change', () => applyChoice(radio.value !== ''));
  });

  if (planSelect) {
    planSelect.addEventListener('change', () => {
      sellingPlanInput.value = planSelect.value;
      const selectedOption = planSelect.options[planSelect.selectedIndex];
      if (subscribePriceEl && selectedOption?.dataset.price) {
        subscribePriceEl.textContent = selectedOption.dataset.price;
      }
    });
  }

  const checkedRadio = root.querySelector('.plan-radio:checked');
  applyChoice(!!checkedRadio && checkedRadio.value !== '');
}
